export default "__VITE_ASSET__CtwuqFBs__"